export enum CalendarTypeEnum {
    month = "month",
    week = "week",
    "2weeks" = "2weeks",
    day = "day",
    "4day" = "4day",
}
